import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserFormValue, UserResponse } from '../types/user.types';

@Injectable({ providedIn: 'root' })
export class UserApiService {
  private http = inject(HttpClient);
  private base = 'user';

  getUser(id: number): Observable<UserResponse> {
    return this.http.get<UserResponse>(`${this.base}/${id}`, {
      params: { include: ['simiqId', 'usernames', 'roles'] }
    });
  }

  createUser(value: UserFormValue): Observable<UserResponse> {
    return this.http.post<UserResponse>(this.base, value);
  }

  updateUser(id: number, value: UserFormValue): Observable<UserResponse> {
    return this.http.put<UserResponse>(`${this.base}/${id}`, value);
  }
}
